import { AnimatePresence, motion } from "framer-motion";
import React from "react";

interface PanelWrapperProps {
  children: React.ReactNode;
  showPanel: boolean;
}

export function PanelWrapper({ children, showPanel }: PanelWrapperProps) {
  return (
    <AnimatePresence mode="sync">
      {showPanel && (
        <motion.div
          className="z-40 h-full  w-full md:w-[90%] max-w-6xl mx-auto"
          initial={{ y: "-100%", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: "-100%", opacity: 0 }}
          transition={{ duration: 0.2, ease: "linear" }}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
